import { render, staticRenderFns } from "./datashow.vue?vue&type=template&id=35ef4188&"
import script from "./datashow.vue?vue&type=script&lang=js&"
export * from "./datashow.vue?vue&type=script&lang=js&"
import style0 from "./datashow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports